/** Nunca pantalla en blanco (CLAUDE.md §6): esto es lo que se ve mientras se
 * comprueba la sesión antes de decidir a qué ruta ir. */
export function LoadingScreen() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg">
      <div
        role="status"
        aria-label="Cargando"
        className="h-8 w-8 rounded-full border-2 border-border border-t-accent motion-safe:animate-spin"
      />
    </div>
  )
}
